__turbopack_context__.v({
  "compare-btn": "BigProductImage-module-scss-module__qoQwKW__compare-btn",
  "compare-btn-wrapper": "BigProductImage-module-scss-module__qoQwKW__compare-btn-wrapper",
  "image-container-outer": "BigProductImage-module-scss-module__qoQwKW__image-container-outer",
  "returning": "BigProductImage-module-scss-module__qoQwKW__returning",
});
